import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "proposal-public__content" }
const _hoisted_2 = { class: "proposal-public__content-row-details" }
const _hoisted_3 = { class: "proposal-public__content-organizer" }
const _hoisted_4 = { class: "proposal-public__content-title" }
const _hoisted_5 = { class: "proposal-public__content-description" }
const _hoisted_6 = { class: "proposal-public__content-location" }
const _hoisted_7 = { class: "proposal-public__content-duration" }
const _hoisted_8 = { class: "proposal-public__content-duration-left" }
const _hoisted_9 = { class: "proposal-public__content-duration-right" }
const _hoisted_10 = { class: "proposal-public__content-matrix" }
const _hoisted_11 = { class: "proposal-public__content-row-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProposalIcon = _resolveComponent("ProposalIcon")!
  const _component_NcEmptyContent = _resolveComponent("NcEmptyContent")!
  const _component_NcGuestContent = _resolveComponent("NcGuestContent")!
  const _component_RespondedIcon = _resolveComponent("RespondedIcon")!
  const _component_NcAvatar = _resolveComponent("NcAvatar")!
  const _component_LocationIcon = _resolveComponent("LocationIcon")!
  const _component_DurationIcon = _resolveComponent("DurationIcon")!
  const _component_NcTimezonePicker = _resolveComponent("NcTimezonePicker")!
  const _component_ProposalResponseMatrix = _resolveComponent("ProposalResponseMatrix")!
  const _component_NcButton = _resolveComponent("NcButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($data.contentView === 'loading' || $data.contentView === 'notfound')
      ? (_openBlock(), _createBlock(_component_NcGuestContent, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_NcEmptyContent, {
              name: $options.blankViewLabel,
              description: $options.blankViewDescription
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_ProposalIcon)
              ]),
              _: 1
            }, 8, ["name", "description"])
          ]),
          _: 1
        }))
      : ($data.contentView === 'responded')
        ? (_openBlock(), _createBlock(_component_NcGuestContent, { key: 1 }, {
            default: _withCtx(() => [
              _createVNode(_component_NcEmptyContent, {
                name: $options.respondedViewLabel,
                description: $options.respondedViewDescription
              }, {
                icon: _withCtx(() => [
                  _createVNode(_component_RespondedIcon)
                ]),
                _: 1
              }, 8, ["name", "description"])
            ]),
            _: 1
          }))
        : ($data.contentView === 'loaded')
          ? (_openBlock(), _createBlock(_component_NcGuestContent, { key: 2 }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_NcAvatar, {
                      user: $data.storedProposal?.uid,
                      displayName: $data.storedProposal?.uname,
                      isNoUser: true
                    }, null, 8, ["user", "displayName"]),
                    _createTextVNode(" " + _toDisplayString($data.storedProposal?.uname || $options.t('calendar', 'Unknown User')), 1)
                  ]),
                  _createElementVNode("h1", _hoisted_4, _toDisplayString($data.storedProposal?.title || $options.t('calendar', 'No Title')), 1),
                  _createElementVNode("div", _hoisted_5, _toDisplayString($data.storedProposal?.description || $options.t('calendar', 'No Description')), 1),
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_LocationIcon),
                    _createTextVNode(" " + _toDisplayString($data.storedProposal?.location || $options.t('calendar', 'No Location')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_DurationIcon),
                      _createTextVNode(" " + _toDisplayString($data.storedProposal?.duration ? $data.storedProposal.duration + ' min' : $options.t('calendar', 'No Duration')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_NcTimezonePicker, {
                        modelValue: $data.userTimezone,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.userTimezone) = $event)),
                        "aria-label": $options.t('calendar', 'Select a different time zone')
                      }, null, 8, ["modelValue", "aria-label"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_ProposalResponseMatrix, {
                      mode: "participant",
                      proposal: $data.storedProposal,
                      response: $data.response,
                      timezoneId: $data.userTimezone,
                      onDateVote: $options.onDateVote
                    }, null, 8, ["proposal", "response", "timezoneId", "onDateVote"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_NcButton, {
                    variant: "primary",
                    onClick: $options.onSubmit
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString($options.t('calendar', 'Submit')), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
  ]))
}